import React, { useEffect } from "react";
import "./index.css";
import { TransformWrapper, TransformComponent, useControls } from "react-zoom-pan-pinch";
import { ctgUnderscoreRemoverfucntion } from "../../utils/func";
import useWindowDimensions from "../../hooks/useDimensions";

const Controls = () => {
  const { zoomIn, zoomOut, resetTransform } = useControls();
  const { width, height } = useWindowDimensions();

  return (
    <div className={`tools ${width <= 1025 && "popUp"}`}>
      <button onClick={() => zoomIn()}>+</button>
      <button onClick={() => zoomOut()}>-</button>
      <button onClick={() => resetTransform()}>x</button>
    </div>
  );
};



const MapShow = ({ venueSvg, categories, ticketData, onHoverCatIdFromEvent, setOnHoverCatIdFromEvent, setOnHoverCatIdFromSvg }) => {

  const processSvg = (svgContent, categories) => {
    if (!svgContent) return "";

    const parser = new DOMParser();
    const svgDoc = parser.parseFromString(svgContent, "image/svg+xml");
    const svgElement = svgDoc.documentElement;
    const allElements = svgElement.querySelectorAll("*");


    allElements.forEach((element) => {
      // Exclude text elements
      if (element.tagName.toLowerCase() === "text") return;

      const classList = Array.from(element.classList);
      const hasCtgClass = classList.some((cls) =>
        cls.includes("_ctg") ||
        cls.includes("grandstand") ||
        cls.includes("grandstand-legend") ||
        cls.includes("general-admission") ||
        cls.includes("general-admission-legend")
      );

      if (hasCtgClass) {
        const matchedCategory = categories.find((category) =>
          classList.some(
            (cls) =>
              cls.includes(`${category.category_id}`) ||
              cls.includes(`${ctgUnderscoreRemoverfucntion(category.category_id)}`)
          )
        );

        if (matchedCategory === undefined) {
          element.classList.add("nosale");
        }
      }
    });

    const serializer = new XMLSerializer();
    return serializer.serializeToString(svgElement);
  };

  const processedSvg = processSvg(venueSvg?.svg, ticketData);


  useEffect(() => {
    const svgContainer = document.querySelector(".svg-container");
    if (svgContainer) {
      const allElements = svgContainer.querySelectorAll("*");

      allElements.forEach((element) => {
        const classList = Array.from(element.classList);
        const hasCtgClass = classList.some((cls) => cls.includes("_ctg"));
        if (hasCtgClass && !classList.includes("nosale")) {
          element.addEventListener("mouseenter", () => {
            const categoryId = classList.find((cls) => cls.includes("_ctg"));
            setOnHoverCatIdFromSvg(classList)
            // setOnHoverCatIdFromEvent(categoryId);
            element.classList.add("active");
          });

          element.addEventListener("mouseleave", () => {
            setOnHoverCatIdFromSvg([])
            element.classList.remove("active");
          });
        }
      });
    }
    return () => {
      const svgContainer = document.querySelector(".svg-container");
      if (svgContainer) {
        const allElements = svgContainer.querySelectorAll("*");

        allElements.forEach((element) => {
          const classList = Array.from(element.classList);
          const hasCtgClass = classList.some((cls) => cls.includes("_ctg"));
          const hasNoSaleClass = classList.includes("nosale");

          // Only remove event listeners for elements that had 'nosale' and '_ctg'
          if (hasCtgClass && hasNoSaleClass) {
            element.removeEventListener("mouseenter", () => { });
            element.removeEventListener("mouseleave", () => { });
          }
        });
      }
    };
  }, [processedSvg]);

  useEffect(() => {
    const svgContainer = document.querySelector(".svg-container");
    if (svgContainer) {
      const allElements = svgContainer.querySelectorAll("*");
      allElements.forEach((element) => {
        const classList = Array.from(element.classList);
        if (onHoverCatIdFromEvent) {
          const hasCtgClass = classList.some((cls) => cls.includes(onHoverCatIdFromEvent));
          if (hasCtgClass) {
            element.classList.add("active");
          }
        }
        else {
          element.classList.remove("active");
        }
      });
    }
  }, [onHoverCatIdFromEvent])

  return (
    <TransformWrapper
    >
      {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
        <>
          <Controls  />
          <TransformComponent>
            <div
              className="svg-container"
              dangerouslySetInnerHTML={{ __html: processedSvg }}
            />
          </TransformComponent>
        </>
      )}
    </TransformWrapper>

  );
};

export default MapShow;
